import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth-context";

export function ProtectedRoute({ children, adminOnly = false, designerOnly = false, anyRole = false }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen grid place-items-center bg-[#050505] text-[#a3a3a3]">
        <span data-testid="auth-loading">Loading…</span>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  if (designerOnly && user.role !== "designer") return <Navigate to="/dashboard" replace />;
  // Default behaviour: client-only route — redirect non-clients to their dashboards.
  // Pass `anyRole` for routes that should render for any authenticated user (e.g., /account).
  if (!adminOnly && !designerOnly && !anyRole) {
    if (user.role === "admin") return <Navigate to="/admin" replace />;
    if (user.role === "designer") return <Navigate to="/designer" replace />;
  }
  return children;
}
